type Theme = "system" | "light" | "dark";
export function useTheme() {
  const theme = useState<Theme>("theme", () => "system");
  watch(theme, () => {
    document.documentElement.classList.toggle("dark", theme.value === "dark");
  });
  return {
    theme,
  };
}
